import { FormControl, FormGroup } from '@angular/forms';
import { SearchModel } from '../search-model';

export const PermWizardListingSearchModel: SearchModel = {

    label: {
        advanceSearchCode: "Code",
        advanceSearchName: "Name",
        advanceSearchDescription: "Description",
    },

    dataType: {
        advanceSearchCode: "string",
        advanceSearchName: "string",
        advanceSearchDescription: "string",
    },

    form: new FormGroup({
        advanceSearchCode: new FormControl(),
        advanceSearchName: new FormControl(),
        advanceSearchDescription: new FormControl(),
    }),

    query: (query) => 
    (query) ? 
    `(hdr.code ILIKE '%${query}%') OR (hdr.name ILIKE '%${query}%') OR (hdr.description ILIKE '%${query}%') AND (hdr.status!='DELETED')` : `(hdr.status='DELETED')`,

    table: 'app_perm_template_hdr',

    queryCallbacks: {
        advanceSearchCode: (advanceSearchCode) =>
        advanceSearchCode ? `hdr.code ILIKE '%${advanceSearchCode}%'` : "",
        advanceSearchName: (advanceSearchName) =>
        advanceSearchName ? `hdr.name ILIKE '%${advanceSearchName}%'` : "",
        advanceSearchDescription: (advanceSearchDescription) => 
        advanceSearchDescription ? `hdr.description = '${advanceSearchDescription}'` : "",
      }
}